import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { AssessmentCard } from './components/AssessmentCard';
import { FlowSection } from './components/FlowSection';
import { HeroSection } from './components/HeroSection';
import { ReassureSection } from './components/ReassureSection';
import styles from './styles.module.scss';

export type AssessmentOption = {
    type: 'easy' | 'detail';
    title: string;
    label?: string;
    badge?: string;
    description: string;
    features: { icon: string; text: string; colored?: boolean }[];
    ctaText: string;
    redirect: string;
    requiresLogin?: boolean;
};

const CU05601PageV2 = () => {
    const options: AssessmentOption[] = [
        {
            type: 'easy',
            title: 'かんたん査定',
            badge: 'おすすめ',
            description:
                'たった4つの質問に答えるだけ。名前や連絡先は不要です。まずはざっくりとした価格を知りたい方にぴったり。',
            features: [
                { icon: 'smartphone', text: 'スマホだけでOK' },
                { icon: 'user-x', text: '個人情報不要' },
                { icon: 'phone-off', text: '電話なし安心' },
            ],
            ctaText: 'かんたん査定をはじめる',
            redirect: PRIVATE_ROUTES.SUB.CU_056_02,
        },
        {
            type: 'detail',
            title: 'くわしく査定',
            label: 'より正確な金額を知りたいとき',
            description:
                '物件の詳しい情報をご入力いただくと、より実際に近い査定額がわかります。ログインが必要です。',
            features: [
                { icon: 'target', text: 'より正確な査定', colored: false },
                { icon: 'list-checks', text: '詳細な物件情報', colored: false },
                { icon: 'log-in', text: 'ログインが必要', colored: false },
            ],
            ctaText: 'くわしく査定へ',
            redirect: PRIVATE_ROUTES.SUB.CU_028_01,
            requiresLogin: true,
        },
    ];

    return (
        <div className={styles.page}>
            <main className={styles.content}>
                <HeroSection />

                <section className={styles.cardSection}>
                    {options.map((option) => (
                        <AssessmentCard key={option.type} {...option} />
                    ))}
                </section>

                <FlowSection flowDetailUrl={LINK_URL.CHECK_ASSESSMENT_METHOD} />

                <hr className={styles.divider} />

                <ReassureSection />

                <footer className={styles.pageFooter}>
                    <p className={styles.footerText}>
                        査定結果はあくまで参考価格です。実際の売却時には不動産会社の訪問査定をおすすめしています。
                    </p>
                </footer>
            </main>
        </div>
    );
};

export default CU05601PageV2;
